import { AfterContentChecked, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import {
  ApiService,
  AuthService,
  ClinicService,
  ConfirmService,
  IntakeService,
  ProgressIndicatorService,
} from '@mmx/shared'
import { TranslateService } from '@ngx-translate/core'

import { BasePartialDirective } from '../base-partial'

@Component({
  selector: 'mmx-custom-section',
  templateUrl: './custom-section.component.html',
  standalone: false,
})
export class CustomSectionComponent
  extends BasePartialDirective
  implements OnInit, AfterContentChecked, OnChanges
{
  recordValue: any
  showSaveButton = true

  constructor(
    authService: AuthService,
    intakeService: IntakeService,
    restService: ApiService,
    fb: UntypedFormBuilder,
    progressService: ProgressIndicatorService,
    confirmService: ConfirmService,
    translateService: TranslateService,
    private clinicService: ClinicService,
  ) {
    super(
      authService,
      intakeService,
      restService,
      fb,
      progressService,
      confirmService,
      translateService,
    )
  }

  ngOnInit() {
    this.createForm()
    // hide the save button if the intake is finalized
    if (
      !this.clinicService.clinic.modules.tech &&
      !this.intake.isNotConfirmed
    ) {
      this.showSaveButton = false
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.customQuestions.currentValue &&
      changes.customQuestions.previousValue &&
      changes.customQuestions.currentValue.length !==
        changes.customQuestions.previousValue.length
    ) {
      // Means there some new fields to show or hide
      this.createForm()
    }
  }

  ngAfterContentChecked(): void {
    if (this.shouldRefresh) {
      this.createForm()
      this.shouldRefresh = false
    }
  }

  createForm() {
    if (this.section.default) {
      this.buildForm(this.customQuestions, this.section.path)
    } else {
      this.buildForm(this.customQuestions)
    }
  }
}
